import { MiddleSection } from "../Components";
import ActiveTournamentsSection from "../Components/Middle/ActiveTournamentsSection";
import { LobbyRoomSection } from "../Components/Middle/LobbyRoomSection";
import LobbyTableSection, {
  RoomTablesSection,
} from "../Components/Middle/RoomTablesSection";

import TournamentsSection from "../Components/Middle/TournamentsSection";
import TournamentDetails from "../Components/Tournaments/TournamentDetails";
import { MainLayout } from "../Pages/MainLayout";

export const LobbyScreen = () => (
  <MainLayout>
    <LobbyRoomSection />
  </MainLayout>
);

export const TournamentsScreen = () => (
  <MainLayout>
    <TournamentsSection />
  </MainLayout>
);
export const TournamentScreen = () => (
  <MainLayout>
    <TournamentDetails />
  </MainLayout>
);
export const MainScreen = () => (
  <MainLayout>
    <MiddleSection />
  </MainLayout>
);
export const RoomScreen = () => (
  <MainLayout>
    <RoomTablesSection
      route={{
        params: {
          roomSlug: "",
        },
      }}
      navigation={undefined}
    />
  </MainLayout>
);

export const ActiveTournamentScreen = () => (
  <MainLayout>
    <ActiveTournamentsSection
      route={{
        params: {
          roomSlug: "",
        },
      }}
      navigation={undefined}
    />
  </MainLayout>
);
